import { AccountCircle } from '@mui/icons-material';
import { AppBar, Button, Toolbar, Typography } from '@mui/material';
import { type Theme, useTheme } from '@mui/material/styles';
import { Link } from 'react-router';
import useMenu from '../../hooks/use-menu';
import CatalogosMenu from './CatalogosMenu';
// import ConsultasMenu from './ConsultasMenu';
import GanadoMenu from './GanadoMenu';
import TablasMenu from './TablasMenu';
import UserMenu from './UserMenu';

const getStyles = (theme: Theme) => ({
  title: {
    marginRight: theme.spacing(2)
  },
  spacing: {
    flexGrow: 1
  }
});

const MainMenu = (props: { user: string }) => {
  const theme = useTheme();
  const classes = getStyles(theme);
  const {
    anchorElem: menuTablasElem,
    openMenu: openMenuTablas,
    closeMenu: closeMenuTablas
  } = useMenu();
  const {
    anchorElem: menuCatalogosElem,
    openMenu: openMenuCatalogos,
    closeMenu: closeMenuCatalogos
  } = useMenu();
  const {
    anchorElem: menuGanadoElem,
    openMenu: openMenuGanado,
    closeMenu: closeMenuGanado
  } = useMenu();
  // const {
  //   anchorElem: menuConsultasElem,
  //   openMenu: openMenuConsultas,
  //   closeMenu: closeMenuConsultas
  // } = useMenu();
  // const {
  //   anchorElem: menuVentaEnRutaElem,
  //   openMenu: openMenuVentaEnRuta,
  //   closeMenu: closeMenuVentaEnRuta
  // } = useMenu();
  const {
    anchorElem: menuUsuarioElem,
    openMenu: openMenuUsuario,
    closeMenu: closeMenuUsuario
  } = useMenu();
  return (
    <>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" color="inherit" sx={classes.title}>
            <Link to="/">Rancho Los Robles</Link>
          </Typography>
          <Button color="inherit" onClick={openMenuTablas}>
            Tablas
          </Button>
          {!!menuTablasElem && <TablasMenu anchorElem={menuTablasElem} onClose={closeMenuTablas} />}
          <Button color="inherit" onClick={openMenuCatalogos}>
            Catálogos
          </Button>
          {!!menuCatalogosElem && (
            <CatalogosMenu anchorElem={menuCatalogosElem} onClose={closeMenuCatalogos} />
          )}
          <Button color="inherit" onClick={openMenuGanado}>
            Ganado
          </Button>
          {!!menuGanadoElem && <GanadoMenu anchorElem={menuGanadoElem} onClose={closeMenuGanado} />}
          {/*
          <Button color="inherit" onClick={openMenuConsultas}>
            Consultas
          </Button>
          {!!menuConsultasElem && (
            <ConsultasMenu anchorElem={menuConsultasElem} onClose={closeMenuConsultas} />
          )}
          <Button color="inherit" onClick={openMenuVentaEnRuta}>
            Venta en Ruta
          </Button>
          {!!menuVentaEnRutaElem && (
            <VentaEnRutaMenu anchorElem={menuVentaEnRutaElem} onClose={closeMenuVentaEnRuta} />
          )}
          */}
          <span style={classes.spacing} />
          <Button color="inherit" onClick={openMenuUsuario} startIcon={<AccountCircle />}>
            {props.user}
          </Button>
          {!!menuUsuarioElem && (
            <UserMenu anchorElem={menuUsuarioElem} onClose={closeMenuUsuario} />
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default MainMenu;
